/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DigitaloceanSshkeysListRsp } from '../models/digitalocean-sshkeys-list-rsp';
import { DigitaloceanSshkeysLookupRsp } from '../models/digitalocean-sshkeys-lookup-rsp';
import { DigitaloceanSshkeysCreateReq } from '../models/digitalocean-sshkeys-create-req';
import { DigitaloceanSshkeysUpdateReq } from '../models/digitalocean-sshkeys-update-req';
import { DigitaloceanSshkeysDeleteRsp } from '../models/digitalocean-sshkeys-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class SshkeysServiceService extends __BaseService {
  static readonly SshkeysListPath = '/api/digitalocean/v2/account/keys';
  static readonly SshkeysCreatePath = '/api/digitalocean/v2/account/keys';
  static readonly SshkeysLookupPath = '/api/digitalocean/v2/account/keys/{key}';
  static readonly SshkeysUpdatePath = '/api/digitalocean/v2/account/keys/{key}';
  static readonly SshkeysDeletePath = '/api/digitalocean/v2/account/keys/{key}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `SshkeysServiceService.SshkeysListParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  SshkeysListResponse(params: SshkeysServiceService.SshkeysListParams): __Observable<__StrictHttpResponse<DigitaloceanSshkeysListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/account/keys`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanSshkeysListRsp>;
      })
    );
  }
  /**
   * @param params The `SshkeysServiceService.SshkeysListParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  SshkeysList(params: SshkeysServiceService.SshkeysListParams): __Observable<DigitaloceanSshkeysListRsp> {
    return this.SshkeysListResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanSshkeysListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  SshkeysCreateResponse(body: DigitaloceanSshkeysCreateReq): __Observable<__StrictHttpResponse<DigitaloceanSshkeysLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/account/keys`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanSshkeysLookupRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  SshkeysCreate(body: DigitaloceanSshkeysCreateReq): __Observable<DigitaloceanSshkeysLookupRsp> {
    return this.SshkeysCreateResponse(body).pipe(
      __map(_r => _r.body as DigitaloceanSshkeysLookupRsp)
    );
  }

  /**
   * @param params The `SshkeysServiceService.SshkeysLookupParams` containing the following parameters:
   *
   * - `key`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  SshkeysLookupResponse(params: SshkeysServiceService.SshkeysLookupParams): __Observable<__StrictHttpResponse<DigitaloceanSshkeysLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/account/keys/${params.key}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanSshkeysLookupRsp>;
      })
    );
  }
  /**
   * @param params The `SshkeysServiceService.SshkeysLookupParams` containing the following parameters:
   *
   * - `key`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  SshkeysLookup(params: SshkeysServiceService.SshkeysLookupParams): __Observable<DigitaloceanSshkeysLookupRsp> {
    return this.SshkeysLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanSshkeysLookupRsp)
    );
  }

  /**
   * @param params The `SshkeysServiceService.SshkeysUpdateParams` containing the following parameters:
   *
   * - `key`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  SshkeysUpdateResponse(params: SshkeysServiceService.SshkeysUpdateParams): __Observable<__StrictHttpResponse<DigitaloceanSshkeysLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/digitalocean/v2/account/keys/${params.key}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanSshkeysLookupRsp>;
      })
    );
  }
  /**
   * @param params The `SshkeysServiceService.SshkeysUpdateParams` containing the following parameters:
   *
   * - `key`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  SshkeysUpdate(params: SshkeysServiceService.SshkeysUpdateParams): __Observable<DigitaloceanSshkeysLookupRsp> {
    return this.SshkeysUpdateResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanSshkeysLookupRsp)
    );
  }

  /**
   * @param key undefined
   * @return A successful response.
   */
  SshkeysDeleteResponse(key: string): __Observable<__StrictHttpResponse<DigitaloceanSshkeysDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/digitalocean/v2/account/keys/${key}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanSshkeysDeleteRsp>;
      })
    );
  }
  /**
   * @param key undefined
   * @return A successful response.
   */
  SshkeysDelete(key: string): __Observable<DigitaloceanSshkeysDeleteRsp> {
    return this.SshkeysDeleteResponse(key).pipe(
      __map(_r => _r.body as DigitaloceanSshkeysDeleteRsp)
    );
  }
}

module SshkeysServiceService {

  /**
   * Parameters for SshkeysList
   */
  export interface SshkeysListParams {
    perPage?: string;
    page?: string;
    fields?: Array<'all' | 'id' | 'name' | 'public_key' | 'fingerprint'>;
  }

  /**
   * Parameters for SshkeysLookup
   */
  export interface SshkeysLookupParams {
    key: string;
    fields?: Array<'all' | 'id' | 'name' | 'public_key' | 'fingerprint'>;
  }

  /**
   * Parameters for SshkeysUpdate
   */
  export interface SshkeysUpdateParams {
    key: string;
    body: DigitaloceanSshkeysUpdateReq;
  }
}

export { SshkeysServiceService }
